import { forwardRef } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import "./container.scss";

const Container = forwardRef(
  ({ isHeaderFixed = false, className = "", children }, ref) => (
    <div
      {...{ ref }}
      className={classnames(
        "neeto-molecules-container",
        { "neeto-molecules-container--header-fixed": isHeaderFixed },
        className
      )}
    >
      {children}
    </div>
  )
);

Container.displayName = "Container";

Container.propTypes = {
  /**
   * Decides whether the `Header` component should be stickied at the top on scroll.
   */
  isHeaderFixed: PropTypes.bool,
  /**
   * Additional classes to be added to the modal
   */
  className: PropTypes.string,
};

export default Container;
